import { staleness, type Device, type DeviceType, type LocationSource, type Staleness } from '@findmy/shared';

export const typeLabel: Record<DeviceType, string> = {
  android: 'Android',
  ios: 'iPhone / iPad',
  linux: 'Linux',
  windows: 'Windows',
  macos: 'Mac',
  other: 'Other',
};

/** Marker colour state: lost mode wins, then how long since the device was last seen. */
export type MarkerState = Staleness | 'lost';

export function markerState(device: Device, now: number): MarkerState {
  return device.isLost ? 'lost' : staleness(device.lastSeenAt, now);
}

export const markerStateClasses: Record<MarkerState, string> = {
  fresh: 'bg-blue-600',
  stale: 'bg-slate-500',
  very_stale: 'bg-red-600',
  lost: 'bg-amber-500',
};

export const sourceLabel: Record<LocationSource, string> = {
  gps: 'GPS',
  network: 'Mobile network',
  wifi: 'Wi-Fi',
  ip: 'IP address (approximate)',
  fused: 'Phone location services',
  other: 'Other',
};
